import { pickUtmParams } from "./params";

const STORAGE_KEY = "ch_utm";
const listeners = new Set<() => void>();
let current: string | undefined;

function load(): string {
  const fromUrl = pickUtmParams(window.location.search);
  if (fromUrl) return fromUrl;
  try {
    return sessionStorage.getItem(STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
}

/** The UTM query of this browsing session (tab); empty on the server or when the visit has none. */
export function getUtm(): string {
  if (typeof window === "undefined") return "";
  return (current ??= load());
}

/** Make the UTMs in `search`, if any, the session's — the latest campaign wins. */
export function captureUtm(search: string): void {
  const utm = pickUtmParams(search);
  if (!utm) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, utm);
  } catch {
    // Storage blocked: the in-memory value still covers client-side navigation.
  }
  if (utm === getUtm()) return;
  current = utm;
  listeners.forEach((listener) => listener());
}

export function subscribeUtm(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
